/**
 * Браузерные хелперы скачивания. Файлы заказов отдаёт owner-scoped эндпоинт
 * `/api/files/{id}/download` (GET с cookie-сессией) — достаточно обычной ссылки/перехода.
 */

/** Инициирует скачивание Blob (Excel-выгрузка): временная object-URL ссылка. */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

/** Скачать файл по URL (owner-scoped download-эндпоинт): анкер с download. */
export function downloadFromUrl(url: string, filename?: string): void {
  const a = document.createElement('a')
  a.href = url
  if (filename) a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
}
